import { Link } from "react-router-dom";
import { Trophy } from "lucide-react";
import { fmtPrice } from "@/lib/currency";

export function TopViewedProducts({ items }) {
  return (
    <div className="rounded-xl border border-[#27272A] bg-[#121212] p-6" data-testid="top-products-7d">
      <div className="flex items-center gap-2">
        <Trophy className="h-4 w-4 text-[#FF9F0A]" />
        <div className="text-xs uppercase tracking-widest text-neutral-500">Most viewed &mdash; last 7 days</div>
      </div>
      <h3 className="font-black text-xl tracking-tight mt-1">Top products</h3>
      {items.length === 0 ? (
        <p className="mt-3 text-sm text-neutral-500" data-testid="top-products-empty">No product views recorded in the last 7 days yet.</p>
      ) : (
        <ol className="mt-4 space-y-2.5">
          {items.map((p, i) => (
            <li key={p.id} className="flex items-center gap-3" data-testid={`top-product-${i}`}>
              <span className="w-5 font-mono text-xs text-neutral-500">{i + 1}</span>
              <div className="h-9 w-9 rounded-md bg-[#1A1A1C] overflow-hidden shrink-0">
                {p.image_url && <img src={p.image_url} alt="" className="h-full w-full object-cover" />}
              </div>
              <div className="min-w-0 flex-1">
                <Link to={`/product/${p.id}`} className="block text-sm text-white truncate hover:underline">{p.title}</Link>
                <div className="text-xs text-neutral-500 truncate">{p.seller_name || "—"} &middot; {p.category} &middot; {fmtPrice(p.price, p.currency)}</div>
              </div>
              <div className="text-right shrink-0">
                <div className="font-mono font-bold text-[#34C759]">{p.views_7d}</div>
                <div className="text-[10px] text-neutral-600">{p.views_total} all-time</div>
              </div>
            </li>
          ))}
        </ol>
      )}
    </div>
  );
}
